import React from "react";
import { Code2, Cog, Palette, PencilRuler, Users, Cpu } from "lucide-react";

const skills = [
	{
		name: "Machine Learning & Data Science",
		icon: <Cpu className="h-6 w-6 text-gray-900 dark:text-white" />, // you can swap icon if you'd like
		technologies: [
			"Pandas",
			"NumPy",
			"scikit-learn",
			"PyTorch",
			"TensorFlow",
			"Classification",
			"Regression",
			"Anomaly Detection",
			"Tableau",
			"Data Analysis",
			"Data Visualization",
			"ETL Pipelines",
		],
	},
	{
		name: "Manufacturing",
		icon: <Cog className="h-6 w-6 text-gray-900 dark:text-white" />,
		technologies: [
			// Core
			"DFM",
			"GD&T",
			"SPC",
			"Quality Control",
			"Design of Experiments (DOE)",
			"Lean Manufacturing",
			"Process Capability",
			"Root Cause Analysis",
			// Ops & Validation (integrated)
			"PLC Programming",
			"MES Design & Integration",
		],
	},
	{
		name: "Mechanical Design",
		icon: <PencilRuler className="h-6 w-6 text-gray-900 dark:text-white" />,
		technologies: [
			"SolidWorks",
			"CATIA",
			"NX",
			"AutoCAD",
			"Ansys/FEA",
			"Tolerance Analysis",
			"Thermodynamics",
			"Fluid Mechanics",
			"structural Analysis",
			"Fixture & Tooling",
			"CNC Machining",
			"Surface Finishing",
			"Design for X (DFX)",
		],
	},
	{
		name: "Software & Systems Engineering",
		icon: <Code2 className="h-6 w-6 text-gray-900 dark:text-white" />,
		technologies: [
			// Languages & CS
			"Python",
			"C/C++",
			"JavaScript",
			"HTML",
			"CSS",
			"Operating Systems",
			"Computer Architecture",
			// Web & APIs
			"React",
			"Django",
			"Express.js",
			"FastAPI",
			"REST",
			// Data/Cloud/DevOps
			"PostgreSQL",
			"AWS",
			"Docker",
			"Linux",
			"Git",
		],
	},

	{
		name: "UX Design",
		icon: <Palette className="h-6 w-6 text-gray-900 dark:text-white" />,
		technologies: [
			"Wireframing",
			"Prototyping",
			"User Flows",
			"Visual Design",
			"Figma",
			"User Research",
			"Usability Testing",
			"Design Systems",
			"Information Architecture",
			"Accessibility (WCAG)",
		],
	},
	{
		name: "Project Management & Leadership",
		icon: <Users className="h-6 w-6 text-gray-900 dark:text-white" />,
		technologies: [
			"Agile/Scrum",
			"Roadmapping",
			"JIRA",
			"Risk Management",
			"Documentation",
			"Presentation",
			"Cross-functional Leadership",
			"Time Management",
		],
	},
];

export function Skills() {
	return (
		<section
			id="skills"
			className="py-12 bg-gray-100 dark:bg-gray-900 transition-colors duration-300"
		>
			<div className="container mx-auto px-4">
				<h2 className="text-3xl font-bold text-center mb-8 text-gray-900 dark:text-white">
					My Skills
				</h2>
				{/* 6 cards: 3 columns on large screens */}
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
					{skills.map((skill, index) => (
						<div
							key={index}
							className="bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 h-full"
						>
							<div className="p-6">
								<div className="flex items-center mb-4">
									<div className="p-2 bg-gray-100 dark:bg-gray-700 rounded-full">
										{skill.icon}
									</div>
									<h3 className="text-xl font-semibold text-gray-900 dark:text-white ml-3">
										{skill.name}
									</h3>
								</div>
								<div className="flex flex-wrap gap-2">
									{skill.technologies.map((tech, techIndex) => (
										<span
											key={techIndex}
											className="text-sm bg-gray-200 text-gray-800 px-3 py-1 rounded-full dark:bg-gray-600 dark:text-white"
										>
											{tech}
										</span>
									))}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
